import React from 'react';
import { SimilarCompaniesResponse } from '../../../services/openai';
import '../../../styles/CompanySearch.css';

interface ResultsTableProps {
  data: SimilarCompaniesResponse;
  onExportCSV: () => void;
}

/**
 * Component to display similar companies in a table format
 */
const ResultsTable: React.FC<ResultsTableProps> = ({ data, onExportCSV }) => {
  const { mainCompany, similarCompanies, commonEquipment } = data;

  return (
    <div className="results-container">
      <h2 className="results-title">Similar Companies Results</h2>
      
      <table className="results-table">
        <thead>
          <tr>
            <th>Company</th>
            <th>Description</th>
            <th>Equipment</th>
            <th>Website</th>
            <th>Contact Person</th>
          </tr>
        </thead>
        <tbody>
          {/* Main company row */}
          <tr className="main-company-row">
            <td>{mainCompany.name}</td>
            <td>{mainCompany.description}</td>
            <td>{mainCompany.equipment}</td>
            <td>
              {mainCompany.website && (
                <a 
                  href={mainCompany.website.startsWith('http') ? mainCompany.website : `https://${mainCompany.website}`} 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  {mainCompany.website}
                </a>
              )}
            </td>
            <td>{mainCompany.contactPerson}</td>
          </tr>
          
          {/* Similar companies rows */}
          {similarCompanies.map((company, index) => (
            <tr key={index}>
              <td>{company.name}</td>
              <td>{company.description}</td>
              <td>{company.equipment}</td>
              <td>
                {company.website && (
                  <a 
                    href={company.website.startsWith('http') ? company.website : `https://${company.website}`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    {company.website}
                  </a>
                )}
              </td>
              <td>{company.contactPerson}</td>
            </tr>
          ))}
        </tbody>
      </table>
      
      {/* Common equipment section */}
      {commonEquipment && (
        <div className="common-equipment">
          <h3 className="common-equipment-title">Common Equipment</h3>
          <p className="common-equipment-content">{commonEquipment}</p>
        </div>
      )}
      
      {/* Export button */}
      <button 
        className="export-button" 
        onClick={onExportCSV}
      >
        <span>Export as CSV</span>
      </button>
    </div>
  );
};

export default ResultsTable;
